/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { MultiButtonModal } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Button } from 'web-ui-components/lib/atoms/buttons';

const AccountPickerModal = ({ content, showErrorModal, onModalClosed }) => (
  <div className="web-ui-components">
    <MultiButtonModal
      buttons={[
        <Button
          display="primary"
          className="c-btn c-btn--default"
          onClick={onModalClosed}
          size="sm"
          key={`AccountPickerModal_Ok_Button_1`}
        >
          Ok
        </Button>,
      ]}
      isOpen={showErrorModal}
      onClose={onModalClosed}
      title={content.accountPickerModalTitle}
    >
      <StandardBody>
        <p>{content.accountPickerModalContent}</p>
      </StandardBody>
    </MultiButtonModal>
  </div>
);

AccountPickerModal.propTypes = {
  content: PropTypes.object.isRequired,
  showErrorModal: PropTypes.bool.isRequired,
  onModalClosed: PropTypes.func.isRequired,
};

export default AccountPickerModal;
